import { Checkbox, Chip, Box } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Cancel from '@mui/icons-material/Cancel';

import StyledTextField from '@shared/components/StyledTextField';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" color="error" />;

const MultiSelectAutocomplete = ({
  items,
  value,
  label,
  formik,
  id,
  handleSelect,
  toSelect,
  toSelectSecond = null,
  toFindAll,
}) => {
  const handleChange = (_e, val) => {
    const hasSelectAll = val?.some(item => item[toFindAll] === 'selectAll');
    const wasSelectAllSelected = value?.some(
      item => item?.[toFindAll] === 'selectAll'
    );

    if (hasSelectAll && !wasSelectAllSelected) {
      handleSelect(items);
    } else if (!hasSelectAll && wasSelectAllSelected) {
      handleSelect([]);
    } else {
      handleSelect(val?.filter(x => x?.[toFindAll] !== 'selectAll'));
    }
  };

  const renderOption = (props, option, { selected }) => {
    const { key, ...otherProps } = props;

    return (
      <Box
        key={key}
        component="div"
        {...otherProps}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
        {option[toSelect]}
        {toSelectSecond && option[toSelectSecond]
          ? `, ${option[toSelectSecond]}`
          : ''}
      </Box>
    );
  };

  return (
    <Box maxWidth="100%" mx="auto" overflow="visible" minWidth={0}>
      <Autocomplete
        limitTags={3}
        multiple
        disablePortal
        clearText="Limpiar"
        id={id || 'autocomplete-id'}
        options={items}
        value={value}
        disableCloseOnSelect
        getOptionLabel={option =>
          `${option[toSelect]} ${option[toSelectSecond] ?? ''}`
        }
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        renderOption={renderOption}
        renderTags={(tags, getTagProps) =>
          tags.map((option, index) => {
            if (option[toFindAll] === 'selectAll') return null;

            const { key, ...tagProps } = getTagProps({ index });

            return (
              <Chip
                key={key}
                label={`${option[toSelect]}${
                  option[toSelectSecond] ? ', ' + option[toSelectSecond] : ''
                }`}
                deleteIcon={<Cancel color="error" />}
                {...tagProps}
              />
            );
          })
        }
        onChange={(_, val) => handleChange(_, val)}
        style={{ width: '100%', minWidth: 0 }}
        renderInput={params => (
          <StyledTextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            formik={formik}
          />
        )}
      />
    </Box>
  );
};

export default MultiSelectAutocomplete;
